<template>
  <Table
    table-title="Products"
    :headers="tableHeaders"
    :items="filteredItems"
    :actions="actions"
    icon="add_shopping_cart"
    :items-per-page="tableOptions.limit"
    :client-search="false"
    :use-debounced-search="true"
    :total-docs="tableOptions.totalDocs"
    :advanced-search-options="advancedSearchOptions"
    :primaryActionText="primaryActionText"
    :primaryActionIcon="primaryActionIcon"
    @updated-pagination="onUpdatedPagination"
    @updated-page="onUpdatedPage"
    @updatedSearchVal="onUpdatedSearchQuery"
    @updatedSortBy="onUpdatedSortBy"
    @updateSortDesc="onUpdatedSortDesc"
    @applyAdvanceFilter="onApplyAdvanceFilter"
    @primary-action-event="$emit('primary-action-event')"
  />
</template>

<script>
import Table from "@/components/Table";

export default {
  name: "ApiTable",
  props: {
    advancedSearchOptions: {
      type: Array,
      required: false,
    },
    tableHeaders: {
      type: Array,
      required: true,
    },
    rowsPerPage: {
      type: Number,
      default: 20,
    },
    defaultSortBy: {
      type: String,
      default: null,
    },
    defaultSortOrder: {
      type: Number,
      default: 1,
    },
    getDataService: {
      type: Function,
      required: true,
    },
    actions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    standardQuery: {
      type: Object,
      default: () => {
        return {};
      },
    },
    primaryActionText: {
      type: String,
    },
    primaryActionIcon: {
      type: String,
    },
  },

  components: {
    Table,
  },
  data() {
    return {
      tableOptions: {
        limit: this.rowsPerPage,
        page: 1,
        skip: 0,
        sortBy: this.defaultSortBy,
        sortOrder: this.defaultSortOrder,
        totalDocs: 999,
      },
      searchTerm: null,
      items: [],
      filteredItems: [],
      advancedFilter: {},
    };
  },
  watch: {
    items() {
      this.filteredItems = this.items;
    },
  },
  methods: {
    async getData() {
      const query = {
        searchTerm: this.searchTerm,
        ...this.standardQuery,
        ...this.advancedFilter,
      };

      const pagination = this.tableOptions;
      const results = await this.getDataService(query, pagination);
      this.items = results.data.docs;
      this.tableOptions.totalDocs = results.data.totalDocs;
    },
    onApplyAdvanceFilter(filter) {
      this.advancedFilter = filter;
      this.getData();
    },
    onUpdatedSortDesc(desc) {
      Object.assign(this.tableOptions, {
        sortOrder: desc ? -1 : 1,
      });
      this.getData();
    },
    onUpdatedSortBy(sortBy) {
      if (sortBy) {
        Object.assign(this.tableOptions, {
          sortBy,
        });
      }
      this.getData();
    },
    onUpdatedSearchQuery(query) {
      const { searchTerm } = query;
      Object.assign(this, {
        searchTerm,
      });
      this.getData();
    },
    onUpdatedPage(page) {
      Object.assign(this.tableOptions, {
        page,
      });
      this.getData();
    },
    onUpdatedPagination(pagination) {
      Object.assign(this.tableOptions, {
        limit:
          pagination.itemsPerPage === -1 ? 999999999 : pagination.itemsPerPage,
        skip: (pagination.page - 1) * pagination.itemsPerPage,
        page: this.tableOptions.page,
      });
      this.getData();
    },
  },
};
</script>
